import React, { useEffect, useRef } from "react";
import { FaPlus, FaTrash } from "react-icons/fa";

const fieldClassName =
  "w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 transition";

const ClientProjectsFields = ({
  projects = [],
  onProjectChange,
  onAddProject,
  onRemoveProject,
}) => {
  const inputRefs = useRef([]);
  const previousProjectCountRef = useRef(projects.length);

  useEffect(() => {
    const previousCount = previousProjectCountRef.current;
    previousProjectCountRef.current = projects.length;

    if (projects.length > previousCount) {
      const newestInput = inputRefs.current[projects.length - 1];
      newestInput?.focus();
      newestInput?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [projects.length]);

  const handleProjectKeyDown = (event, index) => {
    const isLastProject = index === projects.length - 1;
    if (
      event.key !== "Enter" ||
      !isLastProject ||
      !String(projects[index] || "").trim()
    ) {
      return;
    }

    event.preventDefault();
    onAddProject();
  };

  return (
    <section className="rounded-lg border border-gray-200 p-4 dark:border-gray-700">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">
            รายการ Project
          </h3>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            รายการนี้จะใช้เป็นตัวเลือก Project ในหน้า Timesheet
          </p>
        </div>
        <span className="shrink-0 rounded-full bg-indigo-50 px-2.5 py-1 text-xs font-semibold text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
          {projects.length} รายการ
        </span>
      </div>

      {projects.length === 0 ? (
        <p className="mt-4 rounded-md border border-dashed border-gray-300 px-3 py-5 text-center text-sm text-gray-500 dark:border-gray-700 dark:text-gray-400">
          ยังไม่ได้เพิ่ม Project
        </p>
      ) : (
        <div className="mt-4 space-y-3">
          {projects.map((project, index) => (
            <div key={index} className="flex items-end gap-3 rounded-md bg-gray-50 p-3 dark:bg-gray-900/60">
              <div className="min-w-0 flex-1">
                <label className="text-xs font-medium text-gray-600 dark:text-gray-400">Project {index + 1}</label>
                <input
                  ref={(element) => {
                    inputRefs.current[index] = element;
                  }}
                  type="text"
                  value={project}
                  onChange={(event) => onProjectChange(index, event.target.value)}
                  onKeyDown={(event) => handleProjectKeyDown(event, index)}
                  placeholder="เช่น Campaign A"
                  className={fieldClassName}
                />
              </div>
              <button type="button" onClick={() => onRemoveProject(index)} className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-red-500 text-white transition hover:bg-red-600" title="ลบ Project" aria-label={`ลบ Project ${index + 1}`}>
                <FaTrash size={13} />
              </button>
            </div>
          ))}
        </div>
      )}

      <button
        type="button"
        onClick={onAddProject}
        className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-md border border-dashed border-indigo-300 bg-indigo-50 px-4 py-2.5 text-sm font-semibold text-indigo-700 transition hover:border-indigo-400 hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-indigo-400 dark:border-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300 dark:hover:bg-indigo-500/20"
      >
        <FaPlus size={12} /> เพิ่ม Project
      </button>
      <p className="mt-2 text-center text-xs text-gray-500 dark:text-gray-400">
        กด Enter ที่ช่องสุดท้ายเพื่อเพิ่ม Project ถัดไปได้ทันที
      </p>
    </section>
  );
};

export default ClientProjectsFields;
